<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">
                        <!-- Department -->
                        <!-- <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Department :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="departmentId" name="departmentId"
                                    label="text"
                                    @input="changeDepartmentValue"
                                    :options="departmentArr" :clearable=false placeholder="Select Department">
                                </v-select>
                                <div class="help is-danger">{{departmentIdError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div> -->
                        <!-- Tech Name -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Tech Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="techNameError = ''" maxlength="190" class="form-control" v-model="techName" id="techName" name="techName">
                                <div class="help is-danger">{{techNameError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Tech Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Tech Email :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="techEmailError = ''" maxlength="190" class="form-control" v-model="techEmail" id="techEmail" name="techEmail">
                                <div class="help is-danger">{{techEmailError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Tech -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Tech# :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="techError = ''" maxlength="190" class="form-control" v-model="tech" id="tech" name="tech">
                                <div class="help is-danger">{{techError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- RO# -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">RO# :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="roError = ''" maxlength="190" class="form-control" v-model="ro" id="ro" name="ro">
                                <div class="help is-danger">{{roError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Operation# -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Operation# :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="operationError = ''" maxlength="190" class="form-control" v-model="operation" id="operation" name="operation">
                                <div class="help is-danger">{{operationError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- I was paid for -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">I was paid for :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="paidHourError = ''" maxlength="190" class="form-control" v-model="paidHour" id="paidHour" name="paidHour">
                                hour
                                <div class="help is-danger">{{paidHourError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- I should have been paid for -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">I should have been paid for :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="shouldPaidHourError = ''" maxlength="190" class="form-control" v-model="shouldPaidHour" id="shouldPaidHour" name="shouldPaidHour">
                                hour
                                <div class="help is-danger">{{shouldPaidHourError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Location -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Location :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="locationId" name="locationId"
                                    label="name"
                                    @input="locationError = ''"
                                    placeholder="Select Location"
                                    :options="locationArr" :clearable=false>
                                </v-select>
                                <div class="help is-danger">{{locationError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Warranty -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Warranty :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <b-form-radio-group v-model="warranty"
                                    :options="warrantyOptions"
                                    name="warranty">
                                </b-form-radio-group>
                                <div class="help is-danger">{{warrantyError}}</div>
                            </div>
                        </div>
                        <!-- Todays Date -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Todays Date :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{todayDate}}</span>
                            </div>
                        </div>
                        <!-- Occur Date -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Occur Date :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <date-picker @input="occurDateError = ''" placeholder="MM/DD/YYYY" id="occurDate" name="occurDate" v-model="occurDate" :config="options" aria-describedby="basic-addon1"></date-picker>
                                <div class="help is-danger">{{occurDateError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Reason you believe you should be paid? -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Reason you believe you should be paid? :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <textarea @input="reasonError = ''" class="form-control" v-model="reason" id="reason" name="reason"></textarea>
                                <div class="help is-danger">{{reasonError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Are you certified to work on the product? -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Are you certified to work on the product? :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <b-form-radio-group v-model="certifiedWorkProduct"
                                    :options="certifiedWorkProductOptions"
                                    name="certifiedWorkProduct">
                                </b-form-radio-group>
                                <div class="help is-danger">{{certifiedWorkProductError}}</div>
                            </div>
                        </div>
                        <!-- Are you current on your assigned Training? -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Are you current on your assigned Training? :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <b-form-radio-group v-model="cuurentAssignedTraining"
                                    :options="cuurentAssignedTrainingOptions"
                                    name="cuurentAssignedTraining">
                                </b-form-radio-group>
                                <div class="help is-danger">{{cuurentAssignedTrainingError}}</div>
                            </div>
                        </div>
                        <!-- Did the RO have a Job Plan? -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Did the RO have a Job Plan? :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <b-form-radio-group v-model="roJobPlan"
                                    :options="roJobPlanOptions"
                                    name="roJobPlan">
                                </b-form-radio-group>
                                <div class="help is-danger">{{roJobPlanError}}</div>
                            </div>
                        </div>
                        <!-- Did you use the workshop manual to T/S and complete the repair?  -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Did you use the workshop manual to T/S and complete the repair?  :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <b-form-radio-group v-model="workshop"
                                    :options="workshopOptions"
                                    name="workshop">
                                </b-form-radio-group>
                                <div class="help is-danger">{{workshopError}}</div>
                            </div>
                        </div>
                        <!-- Was a JSA filled out? -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Was a JSA filled out? :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <b-form-radio-group v-model="jsaFillOut"
                                    :options="jsaFillOutOptions"
                                    name="jsaFillOut">
                                </b-form-radio-group>
                                <div class="help is-danger">{{jsaFillOutError}}</div>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                        </div>
                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                            <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addUpdateLaborReviewData('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                            <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addUpdateLaborReviewData('save')"><span id="createLaborReview">Save</span></button>
                        </div>

                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";
    import VueTagsInput from '@johmun/vue-tags-input';

    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateLaborReview',
        mixins: [commonMixins],
        components: {
            VueTagsInput,
        },
        data() {
            return {
                pageTitle: 'Add Labor Review',
                edit_id: 0,
                departmentId: "",
                departmentIdError: "",
                departmentArr: [
                    {
                        text: 'Body Shop',
                        value: 'Body Shop',
                    },
                    {
                        text: 'Service',
                        value: 'Service',
                    },
                ],
                techName: "",
                techNameError: "",
                techEmail: "",
                techEmailError: "",
                tech: "",
                techError: "",
                ro: "",
                roError: "",
                operation: "",
                operationError: "",
                paidHour: "",
                paidHourError: "",
                shouldPaidHour: "",
                shouldPaidHourError: "",
                locationId: "",
                locationArr: [],
                locationError: "",
                warranty: "no",
                warrantyError: "",
                warrantyOptions: [
                    {text: 'Yes', value: 'yes'},
                    {text: 'No', value: 'no'},
                ],
                todayDate: "",
                occurDate: "",
                occurDateError: "",
                options: {
                    format: 'MM/DD/YYYY',
                    // maxDate: new Date(),
                },
                reason: "",
                reasonError: "",
                certifiedWorkProduct: "no",
                certifiedWorkProductError: "",
                certifiedWorkProductOptions: [
                    {text: 'Yes', value: 'yes'},
                    {text: 'No', value: 'no'},
                    {text: 'N/A', value: 'n/a'},
                ],
                cuurentAssignedTraining: "no",
                cuurentAssignedTrainingError: "",
                cuurentAssignedTrainingOptions: [
                    {text: 'Yes', value: 'yes'},
                    {text: 'No', value: 'no'},
                ],
                roJobPlan: "no",
                roJobPlanError: "",
                roJobPlanOptions: [
                    {text: 'Yes', value: 'yes'},
                    {text: 'No', value: 'no'},
                ],
                workshop: "no",
                workshopError: "",
                workshopOptions: [
                    {text: 'Yes', value: 'yes'},
                    {text: 'No', value: 'no'},
                ],
                jsaFillOut: "no",
                jsaFillOutError: "",
                jsaFillOutOptions: [
                    {text: 'Yes', value: 'yes'},
                    {text: 'No', value: 'no'},
                ],
                loginUserRoleId: 1,
                bodyShopLocationArr: [],
                serviceLocationArr: [],
            }
        },
        watch: {
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("LaborReview");
            self.todayDate = moment(new Date()).format("MM/DD/YYYY");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }
            this.$nextTick(function () {
                if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                    self.edit_id = self.$route.params.id;
                    self.pageTitle = 'Edit Labor Review';
                    self.getLaborReviewDataById();
                    $("#addAndContinueLaborReviewBtn").hide();
                    $("#createLaborReview").html("Update");
                }
            });
            self.loadBodyShopLocation();
        },
        methods: {
            buttonBack() {
                self.$router.push('/labor/review/list');
            },
            changeDepartmentValue: function (department) {
                self.departmentIdError = "";
                self.locationArr = [];
                self.locationId = "";
                if (department != 'undefined' && department.value) {
                    self.locationArr = self.serviceLocationArr;
                    if(department.value == 'Body Shop') {
                        self.locationArr = self.bodyShopLocationArr;
                    }
                }
            },
            getLaborReviewDataById: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    params: {
                        id: self.edit_id,
                    }
                };
                self.showLoader();
                HTTP.get("/labor/review/get", config)
                        .then(function (response) {
                            // self.departmentId = {text: response.data.content.department_name, value: response.data.content.department_name};
                            self.techName = response.data.content.tech_name;
                            self.techEmail = response.data.content.tech_email;
                            self.tech = response.data.content.tech;
                            self.ro = response.data.content.ro;
                            self.operation = response.data.content.operation;
                            self.paidHour = response.data.content.paid_hour;
                            self.shouldPaidHour = response.data.content.should_paid_hour;
                            setTimeout(function() {
                                self.locationId = {name: response.data.content.location_name, id: response.data.content.location_id, manager_email: response.data.content.manager_email, manager_name: response.data.content.manager_name, is_buswest: false};
                            }, 50);
                            self.warranty = response.data.content.warranty;
                            self.occurDate = response.data.content.occur_date;
                            self.reason = response.data.content.reason;
                            self.certifiedWorkProduct = response.data.content.certified_work_product;
                            self.cuurentAssignedTraining = response.data.content.cuurent_assigned_training;
                            self.roJobPlan = response.data.content.ro_job_plan;
                            self.workshop = response.data.content.workshop;
                            self.jsaFillOut = response.data.content.jsa_fill_out;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            loadBodyShopLocation: function() {
                var config = {
                    params: {
                        slug: "vvg-au",
                        department_id: 8
                    }
                };
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                    .then(function (response) {
                        self.bodyShopLocationArr = response.data.locations;
                        if(self.bodyShopLocationArr && self.bodyShopLocationArr.length > 0) {
                            for(var index = 0; index < self.bodyShopLocationArr.length; index++) {
                                var objLocation = self.bodyShopLocationArr[index];
                                /* if(objLocation['name'] == 'Hope Mills Bodyshop, NC' || objLocation['id'] == 76) {
                                    self.bodyShopLocationArr.splice(index, 1);
                                } */
                                if(objLocation['name'] == 'Whittier, CA' || objLocation['id'] == 12) {
                                    self.bodyShopLocationArr[index]['manager_email'] += ",psegala@vvgtruck.com";
                                }
                                if(objLocation['name'] == 'Las Vegas, NV' || objLocation['id'] == 3) {
                                    self.bodyShopLocationArr[index]['manager_email'] += ",athomason@vvgtruck.com";
                                }
                            }
                            self.bodyShopLocationArr = self.bodyShopLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                        }
                        self.loadLocation();
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "vvg-au",
                        department_id: 2
                    }
                };
                HTTPGUZZLE.get("/api/v1/getlocations", config)
                        .then(function (response) {
                            self.serviceLocationArr = response.data.locations;
                            self.serviceLocationArr = self.serviceLocationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            // console.log(JSON.stringify(self.serviceLocationArr));
                            self.locationArr = self.bodyShopLocationArr.concat(self.serviceLocationArr);
                            self.locationArr = self.locationArr.reduce((acc, current) => {
                                const x = acc.find(item => item.id === current.id);
                                if (!x) {
                                    return acc.concat([current]);
                                } else {
                                    return acc;
                                }
                            }, []);
                            self.locationArr = self.locationArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                        })
                        .catch(function (err) {
                            self.catchHandler(err, function () {});
                        });
            },
            checkForm: function () {
                var checked = true;
                self.departmentIdError = "";
                self.techNameError = "";
                self.techEmailError = "";
                self.techError = "";
                self.roError = "";
                self.operationError = "";
                self.paidHourError = "";
                self.shouldPaidHourError = "";
                self.locationError = "";
                self.occurDateError = "";
                self.reasonError = "";

                /* if (self.departmentId == null || !self.departmentId.value) {
                    self.departmentIdError = "Select Department";
                    if (checked) {
                        checked = false;
                    }
                } */
                if (!self.techName) {
                    self.techNameError = "Please enter Tech Name";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.techEmail) {
                    self.techEmailError = "Please enter Tech Email";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.techEmail && !self.validEmail(self.techEmail)) {
                    self.techEmailError = "Please Enter Valid Tech Email";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.tech) {
                    self.techError = "Please enter Tech";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.ro) {
                    self.roError = "Please enter RO";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.operation) {
                    self.operationError = "Please enter operation";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.paidHour) {
                    self.paidHourError = "Please enter Paid Hour";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.paidHour && !self.numberFormateValidation(self.paidHour)) {
                    self.paidHourError = "Please Enter Valid Paid Hour";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.shouldPaidHour) {
                    self.shouldPaidHourError = "Please enter should have been Paid Hour";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.shouldPaidHour && !self.numberFormateValidation(self.shouldPaidHour)) {
                    self.shouldPaidHourError = "Please Enter Valid should have been Paid Hour";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.locationId == null || !self.locationId.id) {
                    self.locationError = "Select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.occurDate) {
                    self.occurDateError = "Select Occur Date";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.reason) {
                    self.reasonError = "Please Enter Reason";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addUpdateLaborReviewData(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                        };
                        var fields = {
                            id: self.edit_id,
                            // department_name: self.departmentId.value,
                            tech_name: self.techName,
                            tech_email: self.techEmail,
                            tech: self.tech,
                            ro: self.ro,
                            operation: self.operation,
                            paid_hour: self.paidHour,
                            should_paid_hour: self.shouldPaidHour,
                            location_name: self.locationId.name,
                            location_id: self.locationId.id,
                            manager_email: self.locationId.manager_email,
                            manager_name: self.locationId.manager_name,
                            warranty: self.warranty,
                            occur_date: self.occurDate,
                            reason: self.reason,
                            certified_work_product: self.certifiedWorkProduct,
                            cuurent_assigned_training: self.cuurentAssignedTraining,
                            ro_job_plan: self.roJobPlan,
                            workshop: self.workshop,
                            jsa_fill_out: self.jsaFillOut,
                        };
                        self.showLoader();
                        HTTP.post("/labor/review/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    if (flag == 'save') {
                                        self.buttonBack();
                                    } else {                                        
                                        self.clearSaveAndContinue();
                                    }
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            clearSaveAndContinue: function() {
                self.edit_id = 0;
                self.departmentId = "";
                self.techName = "";
                self.techEmail = "";
                self.tech = "";
                self.ro = "";
                self.operation = "";
                self.paidHour = "";
                self.shouldPaidHour = "";
                self.locationId = "";
                self.warranty = "no";
                self.occurDate = "";
                self.reason = "";
                self.certifiedWorkProduct = "no";
                self.cuurentAssignedTraining = "no";
                self.roJobPlan = "no";
                self.workshop = "no";
                self.jsaFillOut = "no";
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Forms/LaborReview/AddUpdateLaborReview.vue